import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CouponModel } from '@shared/models/CouponModel';
import { scratchWinPercent } from '@shared/scratch-probability';

@Component({
    selector: 'app-lucky-prizes-panel',
    templateUrl: './lucky-prizes-panel.component.html',
    styleUrls: ['./lucky-prizes-panel.component.scss']
})
export class LuckyPrizesPanelComponent {

    @Input() coupons: CouponModel[] = [];
    @Input() showProbability: boolean = false;
    @Input() probability: number;

    @ViewChild('termsModal', { static: true }) termsModal: TemplateRef<any>;

    isOpen = false;
    expandedIndex: number | null = null;
    termsCoupon: CouponModel = null;

    constructor(private modalService: NgbModal) { }

    toggle() {
        this.isOpen = !this.isOpen;
    }

    close() {
        this.isOpen = false;
    }

    toggleExpanded(i: number) {
        this.expandedIndex = this.expandedIndex === i ? null : i;
    }

    openTerms(coupon: CouponModel) {
        this.termsCoupon = coupon;
        this.modalService.open(this.termsModal, {
            backdrop: 'static', keyboard: true, scrollable: true, size: 'sm',
            centered: true, windowClass: 'modal-full scratch-terms-modal'
        });
    }

    /** % de obtener cada cupón: P(ganar) * (stock cupón / stock total). */
    couponPercent(coupon: CouponModel): string | null {
        if (!this.showProbability) return null;

        const pWin = scratchWinPercent(this.probability) / 100;

        const totalStock = (this.coupons || []).reduce((acc, c) => acc + Math.max(0, (c.maxQuantity || 0) - (c.quantityAccepted || 0)), 0);
        if (totalStock == 0) return null;

        const stock = Math.max(0, (coupon.maxQuantity || 0) - (coupon.quantityAccepted || 0));
        const pct = pWin * (stock / totalStock) * 100;
        if (pct <= 0) return null;

        return pct >= 1 ? `${pct.toFixed(0)}%` : `${pct.toFixed(1)}%`;
    }
}
